import React from 'react';
import { VStack, Center, HStack, Image as NativeImage, Box } from 'native-base';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { useSpringBigStore, useTheme } from '@springbig/shared';
import { FullScreenBox, Section } from '~/shared/Theme';

type AuthTemplateProps = {
    body: React.ReactNode;
};

export const AuthTemplate = ({
    body,
}: AuthTemplateProps) => {

    const {
        menu_background_primary,
        menu_text,
        radius_md,
    } = useTheme();

    const {
        merchantName,
        tendlcLogoSrc,
    } = useSpringBigStore();

    return (
        <FullScreenBox>
            <HStack
                px={4}
                h={'60px'}
                w={'100%'}
                alignItems={'center'}
                justifyContent={'space-between'}
                backgroundColor={menu_background_primary}
            >
                <VStack space={1}>
                    { merchantName && merchantName !== 'null' &&
                        <Caption
                            color={menu_text}
                            text={'authTemplate.welcome'}
                            textValues={[merchantName]}
                            fontSize={18}
                            fontWeight={'light'}
                            lineHeight={'1em'}
                        />
                    }
                    <Caption
                        color={menu_text}
                        text={'authTemplate.log_in'}
                        fontSize={18}
                        bold
                        lineHeight={'1em'}
                    />
                </VStack>
                <SpIcon icon={faLock} color={menu_text} size={20} />
            </HStack>
            <Section
                px={4}
            >
                <Center py={4}>
                    { tendlcLogoSrc ?
                        <NativeImage
                            resizeMode={'cover'}
                            rounded={radius_md}
                            w={160}
                            h={160}
                            src={tendlcLogoSrc}
                        /> :
                        <Box
                            rounded={radius_md}
                            w={160}
                            h={160}
                        ></Box>
                    }
                </Center>
                { body }
            </Section>
        </FullScreenBox>
    );
};
